import React from "react";
// import Helmet from "../component/common/Helmet";
import { Helmet } from "react-helmet";
import HeaderThree from "../component/header/HeaderThree";
import { FiChevronLeft, FiChevronUp } from "react-icons/fi";

import { Row, Col, Card, CardBody } from "reactstrap";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { isMobile } from "react-device-detect";

const NatureOnTheBoardPage = () => {
  const { t, i18n } = useTranslation();
  const icon = `${process.env.PUBLIC_URL}/assets/images/gp_images/ecoshift-logo-brand-eco-movement-ecoresponsible-ecopositive.webp`;
  const gp_about_us1 = `${process.env.PUBLIC_URL}/assets/images/gp_images/ecoshift-nature-on-the-board-with-seat-voice-voting-rights-new.webp?v=${process.env.REACT_APP_IMAGE_VERSION}`;
  const gp_about_us2 = `${process.env.PUBLIC_URL}/assets/images/gp_images/ecoshift-ecoshift-eco-app-movement-platform-ecoresponsible-ecopositive-ecofriendly-ecocentric-nature-on-the-board-2.webp?v=${process.env.REACT_APP_IMAGE_VERSION}`;

  window.onload = function () {
    // Code runs after full page load
    console.log("Page fully loaded!");
    //const purpose = document.getElementById("purpose");
    //purpose.style.opacity = 0;
    document.querySelector(".header--fixed").classList.add("sticky");
  };

  const history = useHistory();
  const handleGoBack = () => {
    if (document.referrer.includes("ecoshift.eco")) {
      history.goBack();
    } else {
      window.location.href = "https://ecoshift.eco/#about-us";
    }
  };

  return (
    <div className="active-dark bg_color--ugs">
      <Helmet>
        <title>Nature on the board</title>
        <meta
          name="description"
          content="We accelerate the transition to eco-friendly consumption for everyone's enjoyment."
        />
        <meta
          name="keywords"
          content="ecoshift,shift,impact,transition,eco,friendly,consumption,eco-positive,sustainability,biodiversity,ecoresponsible,nature,onboarding,governance,seat,voice,voting,rights,planet,boundaries"
        />
        <meta property="og:title" content="Nature on the board" />
        <meta
          property="og:description"
          content="We accelerate the transition to eco-friendly consumption for everyone's enjoyment."
        />
        <meta property="og:image" content={icon} />
        <meta property="og:url" content={process.env.PUBLIC_URL + "/"} />
        <meta name="twitter:card" content={icon} />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://ecoshift.eco/nature-on-the-board" />
      </Helmet>

      <HeaderThree
        homeLink="/"
        logo="symbol-dark"
        color="color-black"
        alwaysSticky="true"
      />

      {/* Start About us Area  */}
      <Card id="nature-on-board" className="card_color--ugs ">
        <CardBody>
          <div className="slider-wrapper">
            <div id="whoweare" className="fix top-inset-main">
              <div className="service-area creative-service-wrapper pb--80 card_color--ugs ">
                <div className="container">
                  <br />
                  <br />
                  <br />

                  <br />

                  <div className="row">
                    <div className="col-lg-8 col-md-8 mr-4">
                      <p className="section-title-left text-color d-inline-flex align-items-center" style={{marginLeft: isMobile ? "0px" : "-50px"}}>
                        <span
                          className="back-button-border d-inline-flex align-items-center"
                          onClick={handleGoBack}
                          style={{ cursor: "pointer" }}
                        >
                          <FiChevronLeft color="#fff" />
                        </span>
                        <span className="ml-2">{t("Nature on the Board")}</span>
                      </p>

                      <p className="text-blod-description text-left-important text-color mt-3">
                        {t("Giving Nature a seat, a voice, and a vote.")}
                      </p>
                      <br />
                      <p className="text-blod-description text-left-important">
                        {t(
                          "Since the creation of EcoShift mid-2025, Nature sits at the Board of Management. We know that every choice we make shapes our environment, so we designed our governance to ensure Nature is not just considered but truly represented, by giving it a voice and the power to vote."
                        )}
                      </p>
                    </div>

                    <div className="col-lg-3 col-md-3 d-flex justify-content-end align-items-center">
                      <img
                        src={gp_about_us1}
                        alt={t(
                          "ecoshift,ecoshift-eco,app,movement,platform,ecoresponsible,ecopositive,ecofriendly,ecocentric,nature,on,the,board"
                        )}
                        width={isMobile ? "100%" : "300"}
                        className={isMobile ? "mt-2" : ""}
                      />
                    </div>
                  </div>

                  <div className="row mt-4">
                    <div className="col-lg-8 col-md-8 mr-4 justify-content-center">
                      <p className="text-blod-description text-left-important">
                        {t(
                          "Because real change happens when businesses recognise Nature as a partner to respect and listen to, rather than a resource to be used up, having Nature’s say on the board seemed to us like the natural fit. By giving Nature a seat at the table, we’re helping to shape a future that works for everyone, humans and the planet alike."
                        )}
                      </p>
                      <p className="text-blod-description text-left-important">
                        {t(
                          "With the support from Corporate Regeneration, we were able to challenge the status quo of corporate management structure, creating a legally binding framework that puts the interests of Nature at the heart of all we do. In practical terms, this means that all key business decisions are weighed in the perspective of the nine planetary boundaries."
                        )}
                      </p>

                      <p className="text-blod-description text-left-important mt-2">
                        {t(
                          "In every board meeting, Nature’s perspective guides us, reminding us that Nature is not just an inspiration, but a vital stakeholder in everything we do."
                        )}
                      </p>

                      <img
                        src={gp_about_us2}
                        alt={t(
                          "ecoshift,ecoshift-eco,app,movement,platform,ecoresponsible,ecopositive,ecofriendly,ecocentric,nature,on,the,board"
                        )}
                        width="100%"
                        className={isMobile ? "mt-2 mb-2" : "mt-3"}
                      />
                    </div>

                    <div className="col-lg-3 col-md-3">
                      <p className="text-blod-description text-left-important font-bold">
                        {t(
                          "How is Nature’s voice represented in board meetings?"
                        )}
                      </p>

                      <p
                        className=""
                        dangerouslySetInnerHTML={{
                          __html: t(
                            'Nature has been appointed as a non-executive Director on the board of Directors, and is represented by the non-profit legal NGO, <a target="_blank" href="https://www.corporateregeneration.org" style="text-decoration: underline; color: #1466cc;">Corporate Regeneration</a> (asbl).'
                          ),
                        }}
                      ></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </CardBody>
      </Card>
      {/* End About us Area  */}
    </div>
  );
};

export default NatureOnTheBoardPage;
